export default __webpack_public_path__ + "static/media/ic_register.5fe76926.svg";